import React from 'react';

import { List } from 'material-ui/List';
import { ListItem } from 'material-ui/List';
import { toDate, toFriendlyDateStringNoYear } from 'helpers/Formatter';
import constants from 'helpers/constants';
import { localize } from 'react-localize-redux';

const StatusIcon = ({ status }) => {
  const styles = {
    new_badge: {
      opacity: '0.6',
      padding: '0',
      minWidth: '15px',
      textAlign: 'center',
      fontSize: '10px',
      lineHeight: '15px',
      minHeight: '14px',
      borderRadius: '3px',
      color: '#fff',
      display: 'inline-block',
      verticalAlign: 'text-bottom',
      marginRight: '10px',
    },
  };

  if (status === constants.referrals.IN_CONTACT) {
    return <span className="statusTag pending" style={styles.new_badge} />;
  } else if (status === constants.referrals.CONVERTED) {
    return <span className="statusTag open" style={styles.new_badge} />;
  } else if (status === constants.referrals.applying) {
    return <span className="statusTag pending" style={styles.new_badge} />;
  } else if (status === constants.referrals.COMPLETED) {
    return <span className="statusTag closed" style={styles.new_badge} />;
  } else {
    return <span />;
  }
};

const ReferralList = ({ referrals, translate }) => {
  if (!referrals || !referrals.length) {
    return <p style={{ textAlign: 'center' }}>You have not referred anyone yet.</p>;
  }

  return (
    <List style={{ padding: 0 }}>
      {referrals.map((referral, index) => (
        <ListItem
          key={index}
          style={{ fontSize: '15px', color: '#3e3e3e' }}
          primaryText={
            <div style={{ marginTop: '-3px' }}>
              <span style={{ textOverflow: 'ellipsis' }}>
                {referral.referee.name} (Referred to {referral.unit_name})
              </span>
              <br />
              <span style={{ fontSize: '14px', color: '#6F6F6F', textTransform: 'capitalize' }}>
                <StatusIcon status={referral.status} />{' '}
                {translate(`referrals.status.${referral.status}`)}
              </span>
            </div>
          }
          leftIcon={
            <span style={{ color: '#6F6F6F', fontSize: '15px', textAlign: 'center' }}>
              {toFriendlyDateStringNoYear(toDate(referral.date_applied))}
            </span>
          }
        />
      ))}
    </List>
  );
};

export default localize()(ReferralList);
